export const ViewType = {
  setLoading: "[View] setLoading",
};
